// Set while the user is deliberately leaving (signing out, deleting the
// account), so pages that send signed-out visitors to the sign-in modal
// don't flash it on the way out.
let leaving = false;

export const markLeaving = () => {
    leaving = true;
};

export const isLeaving = () => leaving;
